module.exports = __webpack_public_path__ + "media/Loops Perc.b0ae8028.wav";